export default "/assets/images/mila-air-3.png?6d3c116486c12ed37aa78192ee2464e9";